import {STORE_BERTDATA} from "../_CONSTANTS";

export const storeBERTData = (analysisId, responseData) => {
  return({
    type: STORE_BERTDATA,
    payload:{analysisId, responseData: responseData}
  })
}

